import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_MOBILE_BROWSER, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';

// tempexp_17578-start
export const blockOverqueotaViewer = !IS_PAID_USER && !IS_BIZ_USER && !IS_MOBILE_BROWSER ? isFeature('block-overquota-viewer') : false;
// tempexp_17578-end
